/**
 * Product Gallery (in Productdetail).
 * @module ProductGallery
 * @return {Object} public methods.
 */
const ProductGallery = (function () {
    var $slider;
    var $navigatorItems;
    var $navigatorLinks;

    function init() {
        $slider = $('.product-gallery__slider');

        if ($slider.length === 0) return false;

        $slider.slick({
	    accessibility: false,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
	    // Issue: with centerMode gallery does not show background picture, if there is overall only one picture present
            // centerMode: true,
            centerPadding: '0'
        });

        getDOMElements();
        addEventListener();
    }

    function getDOMElements() {
        $navigatorItems = $('.product-gallery__navigator ul li');
        $navigatorLinks = $('.product-gallery__navigator ul li a');
    }

    function addEventListener() {
        $slider.on('beforeChange', onBeforeSlideChange);
        $navigatorLinks.click(onNavigationLinkClick);
    }

    function onBeforeSlideChange(e, slick, currentSlide, nextSlide) {
        $($('.product-gallery__navigator ul li')[currentSlide]).removeClass('is-active');
        $($('.product-gallery__navigator ul li')[nextSlide]).addClass('is-active');
    }

    function onNavigationLinkClick(e) {
        var index;

        $navigatorItems.filter('is-active').removeClass('is-active');
        $(e.target).parents('li').addClass('is-active');

        index = $(e.target).parents('li').index();
        $slider.slick('slickGoTo', index);

        return false;
    }

    // Return public methods
    return {
        init: init
    };
})();

window.ProductGallery = ProductGallery;
export default ProductGallery;
